import 'styles/index.scss';
import 'fonts/index.scss';

import VueDND from 'awe-dnd';
import AsyncComputed from 'vue-async-computed';
import storage from '@lsfe/components/utils/storage';
import request from '@lsfe/components/utils/request-extra';
import '@lsfe/components/styles/index.scss';
import directives from '@lsfe/components/directives';
import * as tools from '@lsfe/tools';
import * as utils from 'utils';
import upload from '@lsfe/components/elementui/upload/index';
import components from './index';

const install = (Vue, opts = { urlPrefix: '' }) => {
    directives.forEach((directive) => {
        Vue.directive(directive.name, directive);
    });
    components.forEach((component) => {
        Vue.component(component.name, component);
    });

    Vue.use(upload);

    Vue.use(AsyncComputed);

    Vue.use(VueDND);

    const args = { prefix: opts.urlPrefix };

    Vue.prototype.$storage = storage;
    Vue.prototype.$go = request(args).go;
    Vue.prototype.$get = request(args).get;
    Vue.prototype.$post = request(args).post;
    Vue.prototype.$hGet = request(args).hGet;
    Vue.prototype.$hPost = request(args).hPost;
    Vue.prototype.$urlPrefix = opts.urlPrefix;
    Vue.prototype.$tools = tools;
    Vue.prototype.$utils = utils;
};

export default {
    install,
};
